// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { AgregarListaButton } from "./Componentes/nueva-lista/AgregarListaButton";
import ListaDeListaDeEmails from "./Componentes/ListaDeListaDeEmails";
import { useAuth } from "../Auth/State/AuthContext";
import { Box, CircularProgress, Stack, Typography } from '@mui/material';

export const DifusionesListas = () => {
    const { hasRole } = useAuth();

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                alignItems: "stretch",
                gap: 4,
                marginTop: "30px",
            }}
        >
            <Box display="flex" alignItems="center" justifyContent="space-between" paddingX="20px">
                <Typography variant="h4">
                    Listas
                </Typography>
                {hasRole(["ROLE_CREAR_DESTINATARIO"]) ? <AgregarListaButton /> : null}
            </Box>
            <Box>
                {hasRole(["ROLE_OBTENER_DESTINATARIOS"]) && (<ListaDeListaDeEmails />)}
            </Box>
        </Box>
    );

}